import api from './client';

export const lecturersService = {
    addLecturer: async (credentials) => {
        const response = await api.post('lecturers', credentials, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    },
    getAllLecturers: async () => {
        const response = await api.get('lecturers');
        return Array.isArray(response?.data?.data) ? { ...response.data, data: response.data?.data?.map((item, index) => ({ ...item, no: index + 1, })) } : {};
    },
    deleteLecturer: async (id) => {
        const response = await api.delete(`lecturers/${id}`);
        return response.data;
    },
    updateLecturer: async (id, credentials) => {
        const response = await api.put(`lecturers/${id}`, credentials, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    },
    changePassword: async (id, credentials) => {
        const response = await api.put(`lecturers/${id}/password`, credentials);
        return response.data;
    },
};